<template>
  <div class="content-container">
    <div class="header">
      <v-row>
        <v-col cols="12" md="8">
          <h1 class="title">{{ $t('DASHBOARD.TITLE') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="8">
              <SearchRepairFile/>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6">
          <v-row class="button-container">
            <v-col cols="12" md="3">
              <v-btn
                class="boom-button waiting-button"
                variant="outlined"
                v-if="checkPermission(['DISTRIBUTOR_RECYCLING_READ'])"
              >
                {{ $t('DASHBOARD.BUTTON.RECONDITION') }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                class="boom-button active-button"
                to="/recycling-module/recycling-page"
                variant="outlined"
                v-if="checkPermission(['DISTRIBUTOR_RECYCLING_READ'])"
              >
                {{ $t('DASHBOARD.BUTTON.RECYCLE') }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                class="boom-button add-repair-file-button"
                to="/repair-file/"
                variant="outlined"
                v-if="checkPermission(['DISTRIBUTOR_ADD_REPAIR_FILE'])"
              >
                {{ $t('DASHBOARD.BUTTON.NEW_REPAIR_FILE') }}
                <img src="@/assets/icons/accounts/cross-hover.svg" alt="icône ajouter" class="pl-2"/>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="9">
          <CurrentRepairFiles/>
        </v-col>
        <v-col cols="12" md="3">
          <v-col cols="12" class="pt-0">
            <CustomerRecover/>
          </v-col>
          <v-col cols="12"
                 v-if="checkPermission(['DISTRIBUTOR_VIEW_ALL_SUMMARY_REPAIR_FILE'])">
            <RepairFileFinalized/>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
    <FooterInfo class="fixed-footer"/>
  </div>
</template>
<script>

import SearchRepairFile from '@/components/dashboard/SearchRepairFile.vue';
import CurrentRepairFiles from '@/components/dashboard/CurrentRepairFiles.vue';
import CustomerRecover from '@/components/dashboard/CustomerRecovery.vue';
import RepairFileFinalized from '@/components/dashboard/RepairFileFinalized.vue';
import FooterInfo from '@/components/dashboard/FooterInfo.vue';

export default {
  name: 'DashboardPage',
  components: {
    FooterInfo,
    RepairFileFinalized,
    CustomerRecover,
    CurrentRepairFiles,
    SearchRepairFile
  },
  mounted() {
    let zendeskScript = document.createElement('script')
    zendeskScript.setAttribute('src', import.meta.env.VITE_ZENDESK_CHAT_URL)
    zendeskScript.setAttribute('id', 'ze-snippet')
    document.head.appendChild(zendeskScript)
  },
  methods: {
    checkPermission(permissionsRequired) {
      return this.$store.getters['auth/hasPermission'](permissionsRequired)
    }
  }
}

</script>

<style scoped>
.header {
  padding: 32px;
  background-color: #FFFFFF
}

.header h1 {
  font-size: 40px;
  font-weight: 900;
  line-height: normal;
}

.v-container {
  padding: 20px;
}

.v-card {
  padding: 32px;
}

.boom-button {
  height: 80px;
}

:deep(.v-btn__content) {
  white-space: normal !important;
}

:deep(.v-col-12) {
  padding: 6px;
}

.title {
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.active-button {
  min-width: 125px;
  width: 100%;
}

.waiting-button {
  background-color: #efefef !important;
  border: solid 1px #efefef !important;
  color: #727272 !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  min-width: 125px;
  cursor: default;
}

.fixed-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #FFFFFF;
  height: 70px !important;
}

.content-container {
  max-height: calc(100vh - 130px);
  overflow-y: auto;
}

@media (max-width: 1280px) {
  .fixed-footer {
    height: 140px !important;
    position: static;

  }

  .content-container {
    max-height: calc(100vh + 40px) !important;
  }
}

.button-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
}
</style>
